import { registerLocaleData } from '@angular/common';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import {
    CUSTOM_ELEMENTS_SCHEMA,
    ErrorHandler,
    forwardRef,
    LOCALE_ID,
    NgModule,
    inject,
    provideAppInitializer,
    provideZonelessChangeDetection,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@app/core/core.module';
import { MaterialModule } from '@app/shared/material/material.module';
import { WINDOW, windowFactory } from '@app/shared/services/window.token';
import {
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
    TranslateCompiler,
    TranslateLoader,
    TranslateModule,
    TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApiModule } from 'api/api.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { lastValueFrom } from 'rxjs';
import './patches/ngx-spinner-patch';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig, initConfig } from './app.config';
import { QuotasComponent } from './core/components/quotas/quotas.component';
import { ApiInterceptor } from './core/interceptors/api.interceptor';
import { GlobalErrorHandler } from './core/services/global-error-handler.service';
import { SelfserviceMainModule } from './external/pages/selfservice/selfservice-main.module';
import { ToastrModule } from 'ngx-toastr';
import { ApiModule as ApiV3Module } from 'api-v3/api.module';
import { ApiModule as ApiBffModule } from 'api-bff/api.module';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

export function loadTranslations(translateService: TranslateService) {
    return () => lastValueFrom(translateService.use('de'));
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

class CustomMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        return 'Missing translation for key: ' + params.key;
    }
}
